import React, { useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import { useUI } from "../../stores/useUI";
import { MapLoadingTrackerItems } from "../../types/MapData.types";

interface LoadableObjectProps {
  modelURL: string;
  mapId: string;
  itemId: string;
  itemType: MapLoadingTrackerItems;
  isShowInLoader: boolean;
  children: (gltf: any) => React.ReactNode;
}

export default function LoadableObject({ 
  modelURL, 
  mapId, 
  itemId, 
  itemType, 
  isShowInLoader,
  children 
}: LoadableObjectProps) {
  const markItemLoaded = useUI((state) => state.markItemLoaded);
  const gltf = useGLTF(modelURL, true, true, () => {
    if (isShowInLoader) {
      markItemLoaded();
    }
  });
  
  useEffect(() => {
    useGLTF.preload(modelURL);
  }, [modelURL]);


  useEffect(() => {
    return () => {
      if (isShowInLoader) {
        useGLTF.clear(modelURL);
      }
    };
  }, []);
  
  return <>{children(gltf)}</>;
}
